import albumSunsetBoulevard from "@/assets/album-neon-shadows.jpg";
import albumCanyonNights from "@/assets/album-midnight-echo.jpg";
import albumHotelMirage from "@/assets/album-silent-thunder.jpg";
import albumPacificBreeze from "@/assets/album-cosmic-drift.jpg";
import albumDustyTrails from "@/assets/album-lost-horizon.jpg";
import albumGoldenState from "@/assets/album-electric-dreams.jpg";
import merchVinyl from "@/assets/merch-vinyl.jpg";
import merchTshirt from "@/assets/merch-tshirt.jpg";
import merchHoodie from "@/assets/merch-hoodie.jpg";

export interface Release {
  id: string;
  title: string;
  type: string;
  year: number;
  description: string;
  image: string;
  date: string;
  status: string;
  platforms: { name: string; url: string }[];
  merchOptions: { name: string; price: string }[];
}

export interface MerchItem {
  id: string;
  title: string;
  category: string;
  price: string;
  description: string;
  image: string;
  info: string;
  purchaseLinks: { name: string; price: string; url: string }[];
}

export interface VideoItem {
  id: string;
  title: string;
  type: string;
  duration: string;
  date: string;
  image: string;
  director?: string;
  description: string;
}

export interface TourDate {
  id: string;
  date: string;
  day: string;
  month: string;
  city: string;
  state: string;
  venue: string;
  eventName: string;
  status: "available" | "sold-out" | "presale";
  price?: string;
  doors?: string;
  showTime?: string;
  description?: string;
}

export const releases: Release[] = [
  {
    id: "neon-shadows",
    title: "Sunset Boulevard",
    type: "LP",
    year: 2024,
    description: "West coast harmonies and open-road anthems",
    image: albumSunsetBoulevard,
    date: "March 1, 2024",
    status: "Available Now",
    platforms: [
      { name: "Apple Music", url: "#" },
      { name: "Spotify", url: "#" },
      { name: "Bandcamp", url: "#" },
      { name: "SoundCloud", url: "#" },
      { name: "YouTube Music", url: "#" },
    ],
    merchOptions: [
      { name: "Vinyl (Black, Limited Edition)", price: "$29.99" },
      { name: "CD (Digipak)", price: "$14.99" },
      { name: "Digital Download (WAV/MP3)", price: "$9.99" },
      { name: "Vinyl + T-Shirt Bundle", price: "$49.99" },
    ],
  },
  {
    id: "midnight-echo",
    title: "Canyon Nights",
    type: "Album",
    year: 2023,
    description: "Recorded live at Laurel Canyon, capturing golden-era magic",
    image: albumCanyonNights,
    date: "September 15, 2023",
    status: "Available Now",
    platforms: [
      { name: "Apple Music", url: "#" },
      { name: "Spotify", url: "#" },
      { name: "Bandcamp", url: "#" },
    ],
    merchOptions: [
      { name: "CD (Digipak)", price: "$14.99" },
      { name: "Digital Download", price: "$9.99" },
    ],
  },
  {
    id: "silent-thunder",
    title: "Hotel Mirage",
    type: "Single",
    year: 2024,
    description: "A shimmering mirage of desert heat and longing",
    image: albumHotelMirage,
    date: "January 15, 2024",
    status: "Available Now",
    platforms: [
      { name: "Apple Music", url: "#" },
      { name: "Spotify", url: "#" },
    ],
    merchOptions: [],
  },
  {
    id: "cosmic-drift",
    title: "Pacific Breeze",
    type: "EP",
    year: 2022,
    description: "Four tracks of breezy California country-rock",
    image: albumPacificBreeze,
    date: "June 1, 2022",
    status: "Available Now",
    platforms: [
      { name: "Apple Music", url: "#" },
      { name: "Spotify", url: "#" },
      { name: "Bandcamp", url: "#" },
    ],
    merchOptions: [
      { name: "Digital Download", price: "$6.99" },
    ],
  },
  {
    id: "lost-horizon",
    title: "Dusty Trails",
    type: "Mixtape",
    year: 2023,
    description: "Acoustic demos and campfire recordings",
    image: albumDustyTrails,
    date: "April 20, 2023",
    status: "Available Now",
    platforms: [
      { name: "SoundCloud", url: "#" },
      { name: "Bandcamp", url: "#" },
    ],
    merchOptions: [],
  },
  {
    id: "electric-dreams",
    title: "Golden State",
    type: "Album",
    year: 2021,
    description: "Debut album of sun-soaked Americana",
    image: albumGoldenState,
    date: "November 10, 2021",
    status: "Available Now",
    platforms: [
      { name: "Apple Music", url: "#" },
      { name: "Spotify", url: "#" },
      { name: "Bandcamp", url: "#" },
    ],
    merchOptions: [
      { name: "Vinyl", price: "$24.99" },
      { name: "CD", price: "$12.99" },
    ],
  },
];

export const merchItems: MerchItem[] = [
  {
    id: "neon-shadows-vinyl",
    title: '"Sunset Boulevard" Vinyl',
    category: "Vinyl",
    price: "$29.99",
    description: "180g black vinyl with exclusive poster insert",
    image: merchVinyl,
    info: "180g black vinyl pressed at Optimal Media. Includes exclusive 18x24 poster featuring alternate artwork. Limited to 1,000 copies worldwide. Comes with digital download card.",
    purchaseLinks: [
      { name: "Bandcamp", price: "$29.99", url: "#" },
      { name: "Official Store", price: "$29.99", url: "#" },
    ],
  },
  {
    id: "midnight-echo-cd",
    title: '"Canyon Nights" CD',
    category: "CD",
    price: "$14.99",
    description: "Enhanced packaging with 12-page booklet and bonus track",
    image: albumCanyonNights,
    info: "Digipak packaging with 12-page booklet featuring exclusive photos and liner notes. Includes one bonus track not available on streaming.",
    purchaseLinks: [
      { name: "Official Store", price: "$14.99", url: "#" },
    ],
  },
  {
    id: "tour-tshirt",
    title: "Desert Highway Tour 2024 T-Shirt",
    category: "Apparel",
    price: "$35.00",
    description: "100% cotton tee with tour dates on back",
    image: merchTshirt,
    info: "100% premium cotton, screen printed. Available in sizes S-XXL. Tour dates printed on back.",
    purchaseLinks: [
      { name: "Official Store", price: "$35.00", url: "#" },
    ],
  },
  {
    id: "logo-hoodie",
    title: "Desert Highway Logo Hoodie",
    category: "Apparel",
    price: "$65.00",
    description: "Premium heavyweight hoodie with embroidered logo",
    image: merchHoodie,
    info: "Premium heavyweight hoodie, 400gsm. Embroidered logo on chest. Available in Black and Grey.",
    purchaseLinks: [
      { name: "Official Store", price: "$65.00", url: "#" },
    ],
  },
  {
    id: "cosmic-drift-poster",
    title: '"Pacific Breeze" Poster',
    category: "Print",
    price: "$25.00",
    description: "18x24 hand-numbered art print, signed by band",
    image: albumPacificBreeze,
    info: "18x24 inch art print on 300gsm archival paper. Hand-numbered, limited edition of 200. Signed by all band members.",
    purchaseLinks: [
      { name: "Official Store", price: "$25.00", url: "#" },
    ],
  },
  {
    id: "electric-dreams-cassette",
    title: '"Golden State" Cassette',
    category: "Cassette",
    price: "$12.99",
    description: "Limited run of 500, includes digital download code",
    image: albumGoldenState,
    info: "Clear shell cassette with printed J-card. Limited run of 500 copies. Includes digital download code for WAV and MP3.",
    purchaseLinks: [
      { name: "Bandcamp", price: "$12.99", url: "#" },
    ],
  },
];

export const videos: VideoItem[] = [
  {
    id: "silent-thunder-mv",
    title: '"Hotel Mirage"',
    type: "Official Music Video",
    duration: "3:45",
    date: "January 15, 2024",
    image: albumHotelMirage,
    director: "Alex Morgan",
    description: "Our latest single captures the shimmering heat of the desert highway. Filmed on location in Joshua Tree, this video brings the mirage to life.",
  },
  {
    id: "midnight-echo-live",
    title: '"Canyon Nights"',
    type: "Live Session",
    duration: "4:12",
    date: "October 1, 2023",
    image: albumCanyonNights,
    description: "An intimate live session recorded at a Laurel Canyon cabin, capturing the warmth and harmony of the golden era.",
  },
  {
    id: "electric-dreams-bts",
    title: '"Golden State"',
    type: "Behind the Scenes",
    duration: "6:20",
    date: "December 5, 2021",
    image: albumGoldenState,
    description: "Go behind the scenes of our debut album recording sessions. Studio footage, songwriting process, and candid moments from the California sessions.",
  },
  {
    id: "neon-shadows-lyric",
    title: '"Sunset Boulevard"',
    type: "Lyric Video",
    duration: "3:58",
    date: "February 20, 2024",
    image: albumSunsetBoulevard,
    description: "Animated lyric video featuring sun-drenched California landscapes that bring the album's west coast themes to life.",
  },
  {
    id: "tour-diary-2023",
    title: "Tour Diary 2023",
    type: "Documentary",
    duration: "12:45",
    date: "January 1, 2024",
    image: albumDustyTrails,
    description: "A documentary following Desert Highway on their 2023 North American tour. Featuring backstage moments, fan interactions, and live performances.",
  },
  {
    id: "cosmic-drift-live",
    title: '"Pacific Breeze"',
    type: "Live at Red Rocks",
    duration: "18:30",
    date: "August 15, 2022",
    image: albumPacificBreeze,
    description: "Full performance of the Pacific Breeze EP live at Red Rocks Amphitheatre. A transcendent evening under the desert sky.",
  },
];

export const tourDates: TourDate[] = [
  {
    id: "brooklyn-mar15",
    date: "15",
    day: "FRI",
    month: "MAR 2024",
    city: "Los Angeles",
    state: "CA",
    venue: "The Troubadour",
    eventName: "Sunset Strip Tour",
    status: "available",
    price: "$35",
    doors: "7:00 PM",
    showTime: "8:30 PM",
    description: "Join us for the opening night of our 2024 Sunset Strip Tour. Performing songs from 'Sunset Boulevard' and fan favorites. Special guest opener: Canyon Echo.",
  },
  {
    id: "la-mar22",
    date: "22",
    day: "FRI",
    month: "MAR 2024",
    city: "San Francisco",
    state: "CA",
    venue: "The Fillmore",
    eventName: "Pacific Coast Sessions",
    status: "available",
    price: "$40",
    doors: "7:30 PM",
    showTime: "9:00 PM",
    description: "Pacific Coast Sessions at the legendary Fillmore. Full Sunset Boulevard album performance.",
  },
  {
    id: "chicago-apr5",
    date: "05",
    day: "FRI",
    month: "APR 2024",
    city: "Denver",
    state: "CO",
    venue: "Red Rocks Amphitheatre",
    eventName: "Heartland Run",
    status: "available",
    price: "$35",
  },
  {
    id: "austin-apr12",
    date: "12",
    day: "FRI",
    month: "APR 2024",
    city: "Austin",
    state: "TX",
    venue: "Mohawk Austin",
    eventName: "Lone Star Nights",
    status: "sold-out",
    price: "$35",
  },
  {
    id: "seattle-apr20",
    date: "20",
    day: "SAT",
    month: "APR 2024",
    city: "Phoenix",
    state: "AZ",
    venue: "The Van Buren",
    eventName: "Desert Nights Run",
    status: "presale",
    price: "$38",
  },
  {
    id: "portland-may3",
    date: "03",
    day: "FRI",
    month: "MAY 2024",
    city: "Nashville",
    state: "TN",
    venue: "Ryman Auditorium",
    eventName: "Southern Highway Show",
    status: "available",
    price: "$35",
  },
];

export const bandMembers = [
  { name: "Technical Consultants", role: "Specialized Engineering & Custom Design" },
  { name: "Support Consultants", role: "24/7 Installation & Maintenance" },
];

export const bandBio = `BA Tents delivers premium event, industrial, and custom tents across the GCC. With over 30 years of expertise, we provide reliable tent solutions for events, exhibitions, weddings, and industrial warehouses at competitive prices.`;
